import React, { useImperativeHandle, useState, useRef, useEffect, useContext } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { EmergenzeApi } from "../../data";
import { apiConfiguration } from "../../apiConfig";
import TenantContext from "../../contexts/tenantContext";
import notify from "devextreme/ui/notify";
import { showError } from "../../utils/errorHandling";
import { LoadPanel } from "devextreme-react";
import EmergenzaAssegnazioneCreate, { EmergenzaAssegnazioneCreateHandle } from "./EmergenzaAssegnazioneCreate";


type Props = {
  emergenzaId: string;
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type EmergenzaAssegnazionePopupHandle = {
  new: () => void
}

type state = {
  visible: boolean
}

const EmergenzaAssegnazionePopup: React.ForwardRefRenderFunction<EmergenzaAssegnazionePopupHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [state, setState] = useState<state>({ visible: false });
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const formRef = useRef<EmergenzaAssegnazioneCreateHandle>(null);

  function hide() {
    setState({ visible: false });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    formRef.current?.save().then(()=>{
      props.onDataChanged?.();
      hide();
    } );
  }

  useImperativeHandle(ref, () => ({
    new() {
       setState({
        visible: true
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
        <Popup
          visible={true}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          fullScreen={fullscreen}
          showTitle={true}
          onHidden={hide}
          title="Nuova assegnazione"
          container=".dx-viewport"
          width={fullscreen ? '100%' : '80%'}
          height={fullscreen ? '100%' : 'auto'}
        >
          <Position
            at="center"
            my="center"
            of=""
            collision="fit"
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="top"
            location="after"
            options={{
              icon: 'fullscreen',
              onClick: () => setFullscreen(!fullscreen),
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Salva',
              type: 'default',
              stylingMode: 'contained',
              onClick: SaveAndClose
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Annulla',
              type: 'normal',
              stylingMode: 'contained',
              onClick: hide
            }}
          />

          <EmergenzaAssegnazioneCreate ref={formRef} emergenzaId={props.emergenzaId} />

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '#form' }}
            visible={loadPanelVisible}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
        </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaAssegnazionePopup);
